import { useState, useEffect } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { FaFacebook, FaGithub, FaLinkedin } from "react-icons/fa";

const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  return (
    <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
      <Container>
        {/* Replace logo with text */}
        <Navbar.Brand href="#home" className="fw-bold fs-4 text-light">
          Tariq <span style={{ color: "#0d6efd" }}>Dev</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              href="#skills"
              className={activeLink === "skills" ? "active navbar-link" : "navbar-link"}
              onClick={() => onUpdateActiveLink("skills")}
            >
              Skills
            </Nav.Link>
            <Nav.Link
              href="#projects"
              className={activeLink === "projects" ? "active navbar-link" : "navbar-link"}
              onClick={() => onUpdateActiveLink("projects")}
            >
              Projects
            </Nav.Link>
             <Nav.Link
              href="#aboutme"
              className={activeLink === "aboutme" ? "active navbar-link" : "navbar-link"}
              onClick={() => onUpdateActiveLink("aboutme")}
            >
              About Me
            </Nav.Link>
            <Nav.Link
              href="#contact"
              className={activeLink === "contact" ? "active navbar-link" : "navbar-link"}
              onClick={() => onUpdateActiveLink("contact")}
            >
              Contact
            </Nav.Link>
           
          </Nav>

          <span className="navbar-text">
            {/* Social Icons */}
            <div className="social-icon mb-2">
          
              <a href="https://www.linkedin.com/in/tariq-mehmood-b31582387/" className="me-3 text-light fs-5">
                <FaLinkedin />
              </a>
              <a href="https://web.facebook.com/tariq.mehmood.731663" className="me-3 text-light fs-5">
                <FaFacebook />
              </a>
            
              <a href="https://github.com/" className="text-light fs-5">
                <FaGithub />
              </a>
            </div>

            {/* Call to Action Button */}
            <Nav.Link
              href="#contact"
              className={activeLink === "contact" ? "active navbar-link" : "navbar-link"}
              onClick={() => onUpdateActiveLink("contact")}
            >
              <button className="vvd">
                <span>Let’s Connect</span>
              </button>
            </Nav.Link>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
